module.exports = __webpack_public_path__ + "static/media/Functional.66c98b76.svg";